var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 1.39844L15.9219 0.578125C15.0625 0.382812 14.2031 0.8125 13.8906 1.59375L12.1719 5.57812C11.8594 6.28125 12.0547 7.14062 12.6797 7.64844L14.2422 8.9375C13.1484 10.9688 11.4297 12.6484 9.39844 13.7812L8.10938 12.2188C7.60156 11.5938 6.74219 11.3984 6.03906 11.7109L2.05469 13.3906C1.27344 13.7422 0.84375 14.6016 1.03906 15.4609L1.85938 19.1328C2.05469 19.9531 2.79688 20.5 3.61719 20.5C13.1875 20.5 21 12.7656 21 3.15625C21 2.33594 20.4141 1.59375 19.5938 1.39844ZM3.69531 18.625L2.875 15.1094L6.70312 13.4688L8.89062 16.125C12.7578 14.2891 14.75 12.2969 16.5859 8.42969L13.9297 6.24219L15.5703 2.41406L19.125 3.23438C19.0859 11.7109 12.1719 18.5859 3.69531 18.625Z",
    fill: "#9C9C9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ef4ad310.svg";
export { ForwardRef as ReactComponent };